import { parsePhoneNumberFromString } from 'libphonenumber-js/min'
export function formatPhone(phone) {
  return parsePhoneNumberFromString(phone, 'US').format("NATIONAL")
}